function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 4,
  r: 3.35,
  stroke: "currentColor",
  strokeWidth: 1.3
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 13.7898C13.9083 10.7011 10.9626 8.48816 7.5 8.48816C4.03743 8.48816 1.09171 10.7011 0 13.7898H1.42428C2.44692 11.4493 4.78241 9.81359 7.49994 9.81359C10.2175 9.81359 12.553 11.4493 13.5756 13.7898H15Z",
  fill: "currentColor"
});

function SvgIcUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjQiIHI9IjMuMzUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMyIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1IDEzLjc4OThDMTMuOTA4MyAxMC43MDExIDEwLjk2MjYgOC40ODgxNiA3LjUgOC40ODgxNkM0LjAzNzQzIDguNDg4MTYgMS4wOTE3MSAxMC43MDExIDAgMTMuNzg5OEgxLjQyNDI4QzIuNDQ2OTIgMTEuNDQ5MyA0Ljc4MjQxIDkuODEzNTkgNy40OTk5NCA5LjgxMzU5QzEwLjIxNzUgOS44MTM1OSAxMi41NTMgMTEuNDQ5MyAxMy41NzU2IDEzLjc4OThIMTVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgIcUser as ReactComponent };